import type { AuthRepository, CheckEmailCommand, CheckEmailResponse } from '../repository/AuthRepository';

export class CheckEmailUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: CheckEmailCommand): Promise<CheckEmailResponse> {
    if (!command.email?.trim()) throw new Error('email is required');

    return this.repository.checkEmail({
      email: command.email.trim(),
    });
  }
}
